import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { ICompanyAutocomplete } from 'partsOld/types';

export const getManyAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICompanyAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/company/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<ICompanyAutocomplete>(data.companies, data.total_count);
};
